'use client';

import { type ReactElement, useContext } from 'react';

import { ModuleWrapper } from '@/app/components/server/module-wrapper';
import { NavbarContext } from '../navbar-context';
import { TopLevelMenu } from '../top-level-menu';
import { type NavbarQuery } from '../types';

type Props = {
  data: NavbarQuery;
};

// Covers the magical screen width range between 992px & 1190px where the navbar
// layout might break menu items into two lines.
// Magic #: 74.375em = 1190px
export const EXCEPTION_MEDIA_QUERY =
  '@media screen and (min-width: 62em) and (max-width: 74.375em)' as const;

export const NavMenu = (props: Props): ReactElement => {
  const {
    data: {
      navbar: { navMenu },
    },
  } = props;

  const { isModalMenuOpen } = useContext(NavbarContext);

  return (
    <ModuleWrapper
      innerProps={{
        as: 'ul',
        direction: ['column', null, null, 'row'],
        gap: [3, null, null, 5],
        listStyleType: 'none',
        sx: {
          [EXCEPTION_MEDIA_QUERY]: { gap: 3, px: 5 },
        },
      }}
      moduleFormat={{
        background: 'transparent',
        spacingBottom: ['0', null, null, '12'],
        spacingTop: ['0', null, null, '12'],
      }}
      outerProps={{
        bg: [null, null, null, 'rgb(255 255 255 / 0.1)'],
        display: isModalMenuOpen ? 'block' : ['none', null, null, 'block'],
      }}
    >
      <TopLevelMenu menuItems={navMenu.menuItems} />
    </ModuleWrapper>
  );
};
